<template>
	<div class="m-navdown">
		<div class="m-navdown-left">
			<button
				type="button"
				class="m-navdown-close"
				:aria-label="t('mHeader.navdown.closeAria')"
				@click="hideMNavdown"
			>
				<img src="./images/close.png" alt="" />
			</button>
		</div>
		<div class="m-navdown-right">
			<div class="m-navdown-content">
				<img class="logo" src="./images/logo.png" alt="" />
				<div>
					<p class="title">{{ t("mHeader.navdown.title") }}</p>
					<p class="desc">{{ t("mHeader.navdown.desc") }}</p>
				</div>
			</div>
			<button type="button" class="btn-download" @click="downloadApp">
				{{ t("mHeader.navdown.download") }}
			</button>
		</div>
	</div>
</template>

<script setup>
import { downloadApp } from "~/utils/common";
import { useI18n } from "~/composables/useI18n";

const { t } = useI18n();

const isShowMNavdown = defineModel();

const hideMNavdown = () => {
	if (import.meta.client) {
		localStorage.setItem("isShowMNavdown", "hide");
	}
	isShowMNavdown.value = false;
};
</script>

<style lang="scss" scoped>
.m-navdown {
	position: relative;
	font-family: PingFang SC;
	display: flex;
	align-items: center;
	background-color: #000000;
	color: #ffffff;
	padding: 20px 25px;

	&-left {
		position: absolute;
		top: 5px;
		right: 10px;
	}

	&-close {
		padding: 0;
		border: 0;
		background: transparent;
		cursor: pointer;

		img {
			display: block;
			width: 32px;
			height: 32px;
		}
	}

	&-right {
		flex: 1;
		display: flex;
		align-items: center;
		min-width: 0;
		padding-right: 32px;
	}

	&-content {
		display: flex;
		align-items: center;
		min-width: 0;
		flex: 1;

		.logo {
			width: 76px;
			margin-right: 16px;
			flex-shrink: 0;
		}

		.title {
			font-weight: 500;
			font-size: 28px;
			line-height: 33px;
			padding-bottom: 12px;
		}

		.desc {
			font-size: 20px;
			line-height: 28px;
			font-weight: normal;
		}
	}

	.btn-download {
		flex-shrink: 0;
		height: 56px;
		border-radius: 198px;
		border: 2px solid #ffffff;
		background: transparent;
		color: #ffffff;
		font-weight: 500;
		font-size: 28px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-left: auto;
		cursor: pointer;
		padding: 0 20px;
		margin-left: 50px;
	}
}
</style>
